<template>
	<wt-selector :options="options" v-model="Value" :disabled="disabled" :props="props" :clearable="true" ></wt-selector>
</template>
<script>
export default {
  name: 'position-selector',
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      Value: this.value,
      options: [],
      props: {
        value: 'id',
        label: 'name'
      }
    }
  },
  watch: {
    value (val) {
      this.Value = val
    },
    Value (val) {
      this.$emit('input', this.Value)
      this.options.forEach(item => {
        if (item.id === val) {
          this.$emit('input', this.Value)
        }
      })
    }
  },
  methods: {
    getList () {
      let data = {
        pageableParam: {
          page: 0,
          size: 9999
        },
        type: 'BRANCH'
      }
      this.$store.dispatch('getBranchCompanyList', data).then(data => {
        this.options = data.data.map(e => {
          return {
            id: e.id,
            name: e.fullName,
            value: e.value
          }
        })
        this.$emit('companyList', data)
      }).catch(err => {
        this.$message.error(err || '获取公司列表失败')
      })
    }
  },
  created () {
    this.getList()
  }
}
</script>
